import { ThemeOptions } from '@mui/material/styles';

import { darkBaseThemeOptions } from '@/shared/features/theme-switcher/themes/base/dark-base-theme';

export const midnightBlueTheme: ThemeOptions = {
  ...darkBaseThemeOptions,
  palette: {
    mode: 'dark',
    primary: {
      main: '#4169FF',
      light: '#203580',
      dark: '#2E4EE6',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#9DA3D4',
      light: '#6A7195',
      dark: '#8285BE',
      contrastText: '#000000',
    },
    danger: {
      main: '#FF4545',
      light: '#4D1A20',
      dark: '#D41F1F',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#C6CAE6',
      additional: '#9599B8',
      disabled: '#6A7195',
    },
    background: {
      default: '#121620',
      paper: '#1A1E2A',
      tooltip: '#2A303D',
      overlay: '#00000080',
      loaderOverlay: '#00000099',
      input: '#1A1E2A',
      clickableHover: '#20358080',
      selectedPaper: '#191F40',
    },
    divider: '#2F3547',
    stroke: {
      primary: '#2F3547',
      secondary: '#303A54',
      secondaryLight: '#444A61',
    },
    status: {
      grey: {
        text: '#BBBFD3',
        stroke: '#2F3547',
        background: '#1A1E2A',
      },
      orange: {
        text: '#FFA040',
        stroke: '#4D3921',
        background: '#2A2015',
      },
      green: {
        text: '#43E628',
        stroke: '#1A4D1E',
        background: '#152015',
      },
      purple: {
        text: '#D9B3FF',
        stroke: '#3E2A80',
        background: '#231A29',
      },
      blue: {
        text: '#5E85FF',
        stroke: '#1B3179',
        background: '#161A2A',
      },
      red: {
        text: '#FF5C5C',
        stroke: '#5D0C0C',
        background: '#291515',
      },
      yellow: {
        text: '#FFDB40',
        stroke: '#5D4E14',
        background: '#292415',
      },
    },
    tag: {
      stroke: '#32374A',
      background: '#25293A',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
      orange: '#FFA040',
    },
    button: {
      primary: {
        background: '#4169FF',
        hoverBackground: '#2E4EE6',
        clickedBackground: '#2E4EE6',
        clickedShadow: '#303A54',
        color: '#FFFFFF',
      },
      secondary: {
        background: '#1A1E2A',
        hoverBackground: '#444A61',
        clickedBackground: '#1A1E2A',
        clickedShadow: '#4169FF',
        color: '#4169FF',
        border: '#303A54',
      },
      alert: {
        background: '#D41F1F',
        hoverBackground: '#D41F1F',
        clickedBackground: '#D41F1F',
        clickedShadow: '#5D0C0C',
        color: '#FFFFFF',
      },
      alertSecondary: {
        background: '#4D1A20',
        hoverBackground: '#291515',
        clickedBackground: '#4D1A20',
        clickedShadow: '#FF4545',
        color: '#FF4545',
        border: '#5D0C0C',
      },
    },
    selectButton: {
      arrowColor: {
        primary: '#4169FF',
        secondary: '#4169FF',
      },
    },
    map: {
      tileFilter: 'brightness(2) contrast(0.9)',
    },
  },
  shadow: {
    drawer: '0px 10px 16px 0px rgba(0, 0, 0, 0.25)',
    menu: '0px 4px 28px 0px rgba(0, 0, 0, 0.35)',
    tooltip: '0px 2px 8px 0px rgba(0, 0, 0, 0.4)',
  },
};
